module.exports = __webpack_public_path__ + "img/预留灵活空间.b296abbd.webp";